import React from 'react';
import Nav from '../Page Components/Nav';
import Footer from "../Page Components/Footer";
import Card from "../Co Components/SquareCards";
import Square from "../Co Components/SquareCards";
import homehero from "../assets/Images/homehero.png";
import Title from "../Co Components/Titles";
import PrimaryButton from "../Co Components/PrimaryButton";
import SecondaryButton from "../Co Components/SecondaryButton";
import HomeCard from "../Co Components/HomeCards";
import HomeCards from "../Co Components/HomeCards";
import LineButton from "../Co Components/LineButton";
import logofoot from '../assets/Images/logo-foot.png';
import Customers from './Customers';
import Certs from './certs';
import Secure from './Secure';
import { Link } from "react-router-dom";
import { useEffect } from 'react';

const Home = () => {
    useEffect(() => {
        window.scrollTo(0, 0)


    });
    return (
        <>

            <Nav />
            <section className={' d-flex flex-row justify-content-lg-between align-items-center '}>
                <article className=' ms-1 articleHeader w-lg-50'>
                    <div className={'mx-5 '}>
                        <h1 className={'text-black headerHome display-4 bold '}><span className={'bolder'}><i>Secure</i></span> your cyberspace,<br />
                            <span className={'bolder'}><i>Secure</i></span> your digital life.</h1>
                    </div>

                    <div className={'w-sm-100 w-lg-75 mx-5 m-lg-5 mt-5 mb-4'}>
                        <p className={'bolde text-black h6'} >
                            <span className='bolder'>The WHITEGUARD</span> is a leading global company, specializing in Cybersecurity, Cloud Computing & Network Security.
                        </p>
                    </div>
                    <div className={'m-lg-5 mx-5'}>
                        <Link to='/contact'><PrimaryButton className={' mt-sm-4 w-120'} text="Secure Me" /></Link>
                        {/*<SecondaryButton className={'mx-lg-4 mt-sm-4'} text="Secure My Business" />*/}

                    </div>
                </article>
                <figure className='w-50  d-none d-lg-block'>
                    <img src={homehero} className={'serviceImage'} />
                </figure>

            </section>
            {/*<Title header={"our"} body={"Customers"} />*/}
            {/*<Customers />*/}

            <Secure />

            <Title header={"our"} body={"SERVICES"} />
            <LineButton />
            <Certs />


            <Title header={"our"} body={"Blogs"} />
            <section className={'d-flex flex-row  flex-wrap justify-content-evenly  '}>
                <div>
                    <article className='danger sectionBlog blog-home-card mx-2 mt-5'>
                        <img src={logofoot} className="blog-home-card-logo" width={'35'} height={'40'} />
                        <h3 className=' line-normal2 fourem'>Egyptian Industry Under Siege: Unmasking the APT Assault </h3>
                        <p className='bolde paraFont'>A Big Industrial company in Egypt was compromised by APT.</p>
                    </article>

                </div>
                <div>
                    <article className='success sectionBlog blog-home-card mx-2 mt-5'>
                        <img src={logofoot} className="blog-home-card-logo" width={'35'} height={'40'} />
                        <h3 className=' line-normal2 mt-4 fourem'>Vineyard Vulnerabilities!!: A Wine Company's Account Takeover Saga</h3>
                        <p className='bolde paraFont'>A big Wine company in Europe was compromised by a zero-click account takeover.</p>
                    </article>

                </div>
                <div >
                    <article className='info  sectionBlog blog-home-card mx-2 mt-5'>
                        <img src={logofoot} className="blog-home-card-logo" width={'35'} height={'40'} />
                        <h3 className=' line-normal2 fourem'>Data Breach Chronicles: an African Government Dilemma</h3>
                        <p className='bolde paraFont'>A prominent government entity in Africa grappled with significant data breaches.</p>
                    </article>

                </div>

            </section>
            <center><Link className={'text-decoration-none '} to={'/blog'}>
                <button className={'primary mt-5'} type={'button'}>Read All Blogs</button>
            </Link></center>

            <Footer />
        </>
    );

}

export default Home;

